import { render, staticRenderFns } from "./addqamess.vue?vue&type=template&id=c6520582&scoped=true"
import script from "./addqamess.vue?vue&type=script&lang=js"
export * from "./addqamess.vue?vue&type=script&lang=js"
import style0 from "./addqamess.vue?vue&type=style&index=0&id=c6520582&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6520582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6520582')) {
      api.createRecord('c6520582', component.options)
    } else {
      api.reload('c6520582', component.options)
    }
    module.hot.accept("./addqamess.vue?vue&type=template&id=c6520582&scoped=true", function () {
      api.rerender('c6520582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/addqamess.vue"
export default component.exports